/**
 * Trims string whitespace.
 */

var _hasTrim = typeof String.prototype.trim === 'function';

export default function trim(str) {
  if (_hasTrim) {
    return str.trim();
  }

  return str.replace(/^\s*|\s*$/g, '');
}
